import { render, staticRenderFns } from "./CustomLottie.vue?vue&type=template&id=0e74e36b&scoped=true&"
import script from "./CustomLottie.vue?vue&type=script&lang=js&"
export * from "./CustomLottie.vue?vue&type=script&lang=js&"
import style0 from "./CustomLottie.vue?vue&type=style&index=0&id=0e74e36b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e74e36b",
  null
  
)

export default component.exports